import { Component } from '@angular/core';

@Component({
  standalone: true,
  imports: [],
  templateUrl: './expired.component.html',
  styleUrl: './expired.component.scss'
})
export class ExpiredComponent {

}
